// overlay-service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OverlayService {
  // BehaviorSubject almacena el estado actual y emite a los nuevos suscriptores
  private overlayState = new BehaviorSubject<boolean>(false);
  
  // Observable para que otros componentes se suscriban
  isOverlayActive$: Observable<boolean> = this.overlayState.asObservable();

  constructor() { }

  show() {
    this.overlayState.next(true);
  }

  hide() {
    this.overlayState.next(false);
  }
}